import React from 'react';
import NumericFormat from 'react-number-format';
import CommonInput from './CommonInput';

const CurrencyInput = ({ inputRef, onChange, name, ...props }) => (
  <NumericFormat
    {...props}
    getInputRef={inputRef}
    onValueChange={(values) => {
      onChange({
        target: {
          name,
          value: values.value, // Raw numeric value
        },
      });
    }}
    customInput={CommonInput} // In
  />
);

export default CurrencyInput;
